<div class="left-side-menu mm-show">
    <a [routerLink]="['/dashboard']" class="logo">
        <span class="logo-lg">
            @if (image.corporateLogoURL && image.display) {
                <img [src]="image.corporateLogoURL" alt="" width="100%" class="img-fluid" />
            }
            @else {
                <img src="../../../assets/images/logo-AA.png" alt="" width="100%" class="img-fluid" />
            }
        </span>
        <span class="logo-sm">
            @if (image.corporateLogoURL && image.display) {
                <img [src]="image.corporateLogoURL" alt="" width="100%" class="img-fluid" />
            }
            @else {
                <img src="../../../assets/images/logo-AA-sm.png" alt="" width="180%" class="img-fluid" />
            }
        </span>
    </a>

    <div class="show" id="left-side-menu-container" data-simplebar>
        <!--- Sidemenu -->
        <ul class="metismenu side-nav">
            @if (security.permitted('contacts', 'contact list', 'view')) {
                <li class="side-nav-item" [routerLink]="['/contacts']" [ngClass]="{'mm-active': active('contact')}">
                    <a class="side-nav-link clickable">
                        <i class="material-icons">people</i>
                        <span>{{words[language].contacts}}</span>
                    </a>
                </li>
            }

            @if (security.permitted('inventory', 'inventory list', 'view')) {
                <li class="side-nav-item" [routerLink]="['/inventory']" [ngClass]="{'mm-active': active('inventory')}">
                    <a class="side-nav-link clickable">
                        <i class="material-icons">directions_car</i>
                        <span>{{words[language].inventory}}</span>
                    </a>
                </li>
            }

            @if (security.permitted('sales', 'sale list', 'view')) {
                <li class="side-nav-item" [routerLink]="['/quotes']" [ngClass]="{'mm-active': active('quote')}">
                    <a class="side-nav-link clickable">
                        <i class="material-icons">format_quote</i>
                        <span>{{words[language].Quotes}}</span>
                    </a>
                </li>
            }

            @if (security.permitted('sales', 'sale list', 'view')) {
                <li class="side-nav-item" [routerLink]="['/sales']" [ngClass]="{'mm-active': active('sale')}">
                    <a class="side-nav-link clickable">
                        <i class="material-icons">sell</i>
                        <span>{{words[language].sales}}</span>
                    </a>
                </li>
            }

            <li class="side-nav-item" [routerLink]="['/accounts']" [ngClass]="{'mm-active': active('account')}">
                <a class="side-nav-link clickable">
                    <i class="material-icons">manage_accounts</i>
                    <span>{{words[language].accounts}} </span>
                </a>
            </li>

            <li class="side-nav-item" [routerLink]="['/collections']" [ngClass]="{'mm-active': active('collect')}">
                <a class="side-nav-link clickable">
                    <i class="material-icons-outlined">paid</i>
                    <span>{{words[language].collections}} </span>
                </a>
            </li>

            <!--
                <li class="side-nav-item" [routerLink]="['/service']" [ngClass]="{'mm-active': active('service')}">
                    <a class="side-nav-link clickable">
                        <i class="material-icons">build</i>
                        <span>{{words[language].service}}</span>
                    </a>
                </li>
            -->

            <li class="side-nav-item" [routerLink]="['/reports']" [ngClass]="{'mm-active': active('reports')}">
                <a class="side-nav-link clickable">
                    <i class="material-icons-outlined">analytics</i>
                    <span>{{words[language].reports}}</span>
                </a>
            </li>

            <!--
                <li class="side-nav-item" [routerLink]="['/communication-center']" [ngClass]="{'mm-active': active('communication')}">
                    <a class="side-nav-link clickable">
                        <span>Communicate</span>
                    </a>
                </li>
            -->

            <li class="side-nav-item" [ngClass]="{'mm-active': active('settings')}" id="settings">
                <a class="side-nav-link" data-toggle="collapse" href="#collapseSettings" aria-controls="collapseSettings" aria-expanded="false" (click)="checkCompact($event)">
                    <i class="material-icons">settings</i>
                    <span>{{words[language].settings}}</span>
                    <span class="menu-arrow"></span>
                </a>
                <ul id="collapseSettings" class="side-nav-second-level collapse" aria-labelledby="headingOne" data-parent="#settings">
                    <!-- Users -->
                    @if (security.permitted('users', 'user list', 'view')) {
                        <li [routerLink]="['/settings/users']" [ngClass]="{'active': active('user')}">
                            <a class="clickable">{{words[language].users}}</a>
                        </li>
                    }

                    <!-- Employees -->
                    @if (security.permitted('users', 'user list', 'view')) {
                        <li [routerLink]="['/settings/employees']" [ngClass]="{'active': active('employee')}">
                            <a class="clickable">{{words[language].employees}}</a>
                        </li>
                    }
                    <!-- Corporations Hierarchy -->
                    @if (security.permitted('corporation setup', 'corporate list', 'view')) {
                        <li [routerLink]="['/settings/corporations']" [ngClass]="{'active': active('corporation')}">
                            <a class="clickable">{{words[language].companySetup}}</a>
                        </li>
                    }
                    <!-- security -->
                    @if (security.permitted('security', 'roles', 'view')) {
                        <li [routerLink]="['/settings/permissions']" [ngClass]="{'active': active('permission')}">
                            <a class="clickable">{{words[language].security}}</a>
                        </li>
                    }
                    @if (security.permitted('corporation setup', 'corporate integrations', 'view')) {
                        <li [routerLink]="['/settings/integration']" [ngClass]="{'active': active('integration')}">
                            <a class="clickable">Integrations</a>
                        </li>
                    }
                    <li [routerLink]="['/settings/gps']" [ngClass]="{'active': active('gps')}">
                        <a class="clickable">Manage GPS Devices</a>
                    </li>
                </ul>
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>

    <!-- LOGO -->
    @if (image.display) {
        <a class="logo logo-bottom" [routerLink]="['/dashboard/']">
            <span class="logo-lg">
                <img src="../../../assets/images/logo-AA.png" alt="" width="180%" class="img-fluid" />
            </span>
        </a>
    }
</div>
